import { render, staticRenderFns } from "./BaseI18nSwitch.vue?vue&type=template&id=7a0c641c&"
import script from "./BaseI18nSwitch.vue?vue&type=script&lang=ts&"
export * from "./BaseI18nSwitch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports